
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking/account",
      function () {
        return require("private-next-pages/booking/account.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booking/account"])
      });
    }
  